/* eslint-disable eqeqeq */
/* Component: AsDropdown
 * Author:    AM
 * Date:      16/03/2021
 *      AsDropdown is a custom select box with extended functionality.
 *      Tickboxes can be enabled by passing the onTick(elementId) function.
 *      An Apply button can be enabled by passing the onApply(event) function.
 *      onOpen() and onClose() get fired when the tongue is expanded or collapsed, respectively.
 */
import ScrollableContent from '../../Scrolling/ScrollableContent';
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Tickbox, Spacer, AsLabel, AsButton, IconChevron, IconClose } from '@adserve/adserve-react-components';

const buttonStyle = {
    height: 34,
    width: 96,
    marginTop: 20,
    fontSize: 15,
    fontWeight: 'bold'
};

const buttonDivStyle = {
    display: 'flex',
    justifyContent: 'center',
    height: 60
};

const dropDownStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #cccccc',
    borderRadius: '0 0 15px 15px',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
    flexDirection: 'column',
    padding: '16px 0 10px 0',
    position: 'relative',
    top: -30,
    zIndex: 10000,
    maxHeight: 605
};

const visibleItems = 15;

const AsDropdown = ({
    values,
    selectedValues,
    onChange,
    indexKey,
    multiSelect = true,
    width,
    applyRequired = true,
    disabled
}) => {
    const [localValues, setLocalValues] = useState([]);

    const [expanded, updateExpanded] = useState(false);
    const [render, setRender] = useState(0);
    const clearChanges = () => {
        onChange(selectedValues);
        console.log('clearexpanded', indexKey);
        updateExpanded(false);
    };
    const DropdownArrow = ({ style }) => {
        return (
            <svg width={13} height={10} viewBox='0 0 13 10' version='1.1' id='SVGRoot' style={style}>
                <g>
                    <path id='path2549' d='M 0,0 6,10 13,0 Z' style={{ fill: '#faa800', fillOpacity: 1 }} />
                </g>
            </svg>
        );
    };

    const outClick = (e) => {
        const p = e.target.closest('.content' + indexKey);

        if (!p) {
            updateExpanded(false);
            console.log('outclickexpanded', indexKey);
        } else {
            e.stopPropagation();
        }
    };
    const contentClick = (e) => {
        e.stopPropagation();
    };

    const asDropdownTickBoxTextFormatter = (array, array2) => {
        // const defaultValue = array?.find((s) => s.id === -99);
        const lookupValue = (array, vl) => {
            for (let i = 0; i < array?.length; i++) {
                if (array[i].id === vl) return array[i];
                if (array[i].children?.length) {
                    for (let j = 0; j < array[i].children.length; j++) {
                        if (array[i].children[j]?.id === vl) return array[i].children[j];
                    }
                }
            }
            return null;
        };

        switch (array2?.length) {
            case 0:
                return window.translate('Select...');
            case 1:
                return lookupValue(array, array2[0])?.name;
            case array?.length:
                return window.translate('All');
            default:
                return window.translate(`Multiple (${getSelectedItemsLength(array2)})`);
        }
    };

    const getSelectedItemsLength = (arr) => {
        let retVal = 0;
        let exitFlg = false;
        const localCheckChildren = (elm, id2find) => {
            if (elm.children) {
                for (let e = 0; e < elm.children.length; e++) {
                    localCheckChildren(elm.children[e], id2find);
                    if (exitFlg) {
                        break;
                    }
                }
            } else {
                if (elm?.id == id2find) {
                    retVal++;
                    exitFlg = true;
                }
            }
        };
        for (let i = 0; i < arr.length; i++) {
            exitFlg = false;
            for (let j = 0; j < values?.length; j++) {
                localCheckChildren(values[j], arr[i]);
                if (exitFlg) {
                    break;
                }
            }
        }
        return retVal;
    };

    const getParent = (id) => {
        let retVal;
        let exitFlg = false;
        let tmp;
        const localCheckChildren = (elm, id, currentParent = null) => {
            if (currentParent && elm?.id == id) {
                retVal = currentParent;
                exitFlg = true;
            } else if (elm.children) {
                tmp = elm;
                for (let e = 0; e < elm.children.length; e++) {
                    localCheckChildren(elm.children[e], id, elm);
                    if (exitFlg) {
                        break;
                    }
                }
            } else {
                if (elm?.id == id) {
                    retVal = tmp;
                    exitFlg = true;
                }
            }
        };
        for (let i = 0; i < values.length; i++) {
            tmp = values[i];
            if (tmp?.id == id) {
                retVal = undefined;
                break;
            }
            localCheckChildren(values[i], id);
            if (exitFlg) {
                break;
            }
        }
        return retVal;
    };

    useEffect(() => {
        document.addEventListener('click', outClick);

        return () => {
            document.removeEventListener('click', outClick);
        };
    }, []);
    useEffect(() => { }, [expanded]);

    useEffect(() => {
        setLocalValues([...selectedValues]);
    }, [selectedValues]);

    useEffect(() => { }, [render]);

    const toggleValue = (e, id) => {
        e.stopPropagation();

        const current = localValues?.find((s) => {
            return s == id;
        });

        if (current) {
            let cv;
            for (let k = 0; k < values.length; k++) {
                const a = values[k];
                if (a.id === current) cv = a;
                for (let i = 0; i < a.children?.length; i++) {
                    if (a.children[i].id === current) cv = a.children[i];

                    for (let j = 0; j < a.children[i].children?.length; j++) {
                        if (a.children[i].children[j].id === current) cv = a.children[i].children[j];
                    }
                }
            }

            if (!cv) return;
            const kys = {};
            kys[cv.id] = current;
            for (let i = 0; i < cv.children?.length; i++) {
                kys[cv.children[i].id] = cv.children[i].id;

                for (let j = 0; j < cv.children[i].children?.length; j++) {
                    kys[cv.children[i].children[j].id] = cv.children[i].children[j].id;
                }
            }

            const newValues = localValues.filter((s) => {
                return !kys[s];
            });

            const unqArr = newValues.filter((itm, pos) => {
                return newValues.indexOf(itm) == pos;
            });
            let retArr = unqArr;
            let currentId = id;
            let hasParent = true;
            while (hasParent) {
                const p = getParent(currentId);
                if (p) {
                    retArr = retArr.filter((itm) => {
                        return itm != p?.id;
                    });
                    currentId = p.id;
                } else {
                    hasParent = false;
                }
            }
            setLocalValues(retArr);

            if (!applyRequired) {
                // Code to UnTick the Checkbox
                console.log('noapply', currentId);
                if (currentId === window.emptyGuid || currentId === -99) {
                    console.log('clearthen');
                    onChange([], indexKey);
                } else {
                    onChange(
                        retArr.filter((f) => f.id !== window.emptyGuid),
                        indexKey
                    );
                }
            }
        } else {
            const s = typeof id;

            if (s === 'number' && parseInt(id) < 0) {
                if (!applyRequired) {
                    if (id === window.emptyGuid || id === -99) {
                        if (indexKey === 'weeks') {
                            onChange([-99], indexKey);
                        } else {
                        onChange([window.emptyGuid], indexKey);
                    }
                    } else {
                        onChange([id], indexKey);
                    }
                }
                setLocalValues([id]);
            } else {
                if (localValues) {
                    const newvls = localValues.filter((s) => typeof s === 'string' || s >= 0);
                    newvls.push(id);
                    let obj;

                    for (let k = 0; k < values.length; k++) {
                        const a = values[k];
                        if (a.id === id) obj = a;
                        for (let i = 0; i < a.children?.length; i++) {
                            if (a.children[i].id === id) obj = a.children[i];

                            for (let j = 0; j < a.children[i].children?.length; j++) {
                                if (a.children[i].children[j].id === id) obj = a.children[i].children[j];
                            }
                        }
                    }

                    if (obj) {
                        for (let i = 0; i < obj.children?.length; i++) {
                            newvls.push(obj.children[i].id);
                            for (let j = 0; j < obj.children[i].children?.length; j++) {
                                newvls.push(obj.children[i].children[j].id);
                            }
                        }
                    }

                    const unqArr = newvls.filter((itm, pos) => {
                        return newvls.indexOf(itm) == pos;
                    });
                    const retArr = unqArr;
                    let currentId = id;
                    let hasParent = true;
                    while (hasParent) {
                        const p = getParent(currentId);
                        if (p) {
                            if (p.children) {
                                let allChildrenSelected = true;

                                for (let i = 0; i < p.children?.length; i++) {
                                    if (retArr.indexOf(p.children[i]?.id) === -1) {
                                        allChildrenSelected = false;
                                        break;
                                    }
                                }

                                if (allChildrenSelected) {
                                    retArr.push(p?.id);
                                }
                            }
                            currentId = p.id;
                        } else {
                            hasParent = false;
                        }
                    }
                    if (!applyRequired) {
                        if (currentId === window.emptyGuid || currentId === -99) {
                            if (indexKey === 'weeks') {
                                onChange([-99], indexKey);
                            } else {
                                onChange([window.emptyGuid], indexKey);
                            }
                        } else {
                            if (indexKey !== 'weeks') {
                                const index = retArr.indexOf(window.emptyGuid);
                                if (index !== -1) {
                                    retArr.splice(index, 1);
                                }
                            }
                            onChange(
                                retArr.filter((f) => f.id !== window.emptyGuid),
                                indexKey
                            );
                        }
                    }
                    setLocalValues(retArr);
                }
            }
        }
    };
    const toggleExpanded = () => {
        updateExpanded(!expanded);

        setRender(render + 1);
    };
    const selectSingleValue = (e) => {
        const id = e.target.getAttribute('data-id');
        const newvls = [id];

        onChange(newvls, indexKey);
    };
    const tryToggleExpanded = (e) => {
        if (disabled) {
            e.stopPropagation();
            return false;
        }

        toggleExpanded();
    };
    const descriptionStyle = {
        backgroundColor: disabled ? '#F7F7F7' : '#FFFDF4',
        borderRadius: 5,
        border: '1px solid #D7D7D7',
        height: 32,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: 500,
        color: '#414141',
        zIndex: 99,
        position: 'relative'
    };

    const labelStyle = {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#414141',
        marginBottom: 10
    };
    const collapse = (v) => {
        v.isExpanded = false;
        v.children?.map((a, b) => collapse(a));
    };
    const arrowClick = (e, current) => {
        e.stopPropagation();
        current.isExpanded = !current.isExpanded;
        if (!current.isExpanded) collapse(current);

        setRender(render + 1);
    };

    const itemStyle = (indent, scrollableItem, itemIndex, isLastItem) => {
        let style = {
            display: 'flex',
            marginLeft: indent,
            marginTop: 5
        };
        if (scrollableItem) {
            if (itemIndex === 0) {
                style = { ...style, paddingTop: 10 };
            } else if (isLastItem) {
                style = { ...style, paddingBottom: 10 };
            }
        }
        return style;
    };

    const countItems = (itemsCount, vals) => {
        vals?.map((a) => {
            if (a.name == '-') {
                itemsCount++;
            } else {
                itemsCount++;
                if (a.children && a.isExpanded) itemsCount += countItems(itemsCount, a.children);
            }
        });
        return itemsCount;
    };

    const showItems = (items, vals, indent, numberOfItems, showFixedItems = false) => {
        vals?.map((a, b) => {
            if ((!(a.id < 0) && a.name != '-' && !showFixedItems) || ((a.id < 0 || a.name == '-') && showFixedItems)) {
                if (a.name == '-') {
                    items.push(
                        <div
                            style={{
                                borderBottom: '1px solid #CCCCCC',
                                height: 2,
                                marginBottom: numberOfItems > visibleItems ? 0 : 16
                            }}
                        ></div>
                    );
                } else {
                    items.push(
                        <div
                            style={itemStyle(
                                indent,
                                !showFixedItems && numberOfItems > visibleItems,
                                items?.length,
                                b === vals?.length - 1
                            )}
                            key={'opt' + a.name + '-' + b}
                        >
                            {multiSelect ? (
                                <>
                                    <Tickbox
                                        data-id={a.id}
                                        style={{
                                            width: 18,
                                            height: 18,
                                            marginTop: -2,
                                            marginLeft: 14
                                        }}
                                        onClick={(e) => toggleValue(e, a.id)}
                                        value={localValues?.find((s) => s == a.id) == a.id}
                                    />
                                    <Spacer width={12} />
                                    <AsLabel style={labelStyle}>{a.name}</AsLabel>
                                    {a.children ? (
                                        <div onClick={(e) => arrowClick(e, a)}>
                                            <DropdownArrow
                                                style={{
                                                    transform: `rotate(${a.isExpanded ? 0 : 270}deg)`,
                                                    cursor: 'pointer',
                                                    padding: '0px 11px',
                                                    opacity: 1
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            ) : (
                                <div
                                    onClick={selectSingleValue}
                                    data-id={a.id}
                                    style={{
                                        ...labelStyle,
                                        marginLeft: 18,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {a.name}
                                </div>
                            )}
                        </div>
                    );
                    if (a.children && a.isExpanded) showItems(items, a.children, indent + 30);
                }
            }
        });
    };
    const content = () => {
        const items = [];
        const Fixeditems = [];
        const itemNum = 0;
        const numberOfItems = countItems(itemNum, values);

        showItems(items, values, 0, numberOfItems);
        showItems(Fixeditems, values, 0, numberOfItems, true);
        const itemCount = items.length;
        const fixedItemCount = Fixeditems.length;
        const fixedItemsHeight = fixedItemCount * 30;
        if (!expanded) {
            return <></>;
        }
        if (itemCount + fixedItemCount > visibleItems) {
            return (
                <div
                    className={'content' + indexKey}
                    displayState={expanded}
                    style={{
                        ...dropDownStyle,
                        width: width + 6
                    }}
                    onClick={contentClick}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            position: 'relative',
                            top: -20,
                            left: 6,
                            height: 30
                        }}
                    >
                        <IconClose
                            style={{
                                cursor: 'pointer',
                                marginTop: 10,
                                marginRight: 10
                            }}
                            width={14}
                            height={14}
                            onClick={() => updateExpanded(false)}
                        ></IconClose>
                    </div>
                    {fixedItemCount > 0 ? <div style={{ marginTop: -15 }}>{Fixeditems}</div> : null}
                    <ScrollableContent style={{ height: 500 - fixedItemsHeight }}>{items}</ScrollableContent>
                    {applyRequired ? (
                        <div
                            style={{
                                ...buttonDivStyle,
                                borderTop: '1px solid #cccccc'
                            }}
                        >
                            <AsButton style={buttonStyle} handleClick={applyChanges}>
                                {window.translate('Apply')}
                            </AsButton>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            );
        } else {
            return (
                <div
                    className={'content' + indexKey}
                    // ToDo: To avoid console warning, pass a string instead of boolean. Can't see a point to write 'state' to the DOM.
                    state={expanded.toString()}
                    style={{
                        ...dropDownStyle,
                        width: width + 2
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            position: 'relative',
                            top: -20,
                            left: 6,
                            height: 30
                        }}
                    >
                        <IconClose
                            style={{
                                cursor: 'pointer',
                                marginTop: 10,
                                marginRight: 10
                            }}
                            onClick={() => clearChanges()}
                            width={14}
                            height={14}
                        ></IconClose>
                    </div>
                    {fixedItemCount > 0 ? <div style={{ marginTop: -15 }}>{Fixeditems}</div> : null}
                    {items}
                    {multiSelect && applyRequired ? (
                        <div style={{ ...buttonDivStyle, marginTop: -5 }}>
                            <AsButton style={buttonStyle} handleClick={applyChanges}>
                                {window.translate('Apply')}
                            </AsButton>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            );
        }
    };
    const applyChanges = () => onChange(localValues, indexKey);

    return (
        <div className={'content' + indexKey} style={{ width: width }} key={'content' + indexKey}>
            <div
                onClick={tryToggleExpanded}
                style={{
                    ...descriptionStyle,
                    cursor: disabled ? 'default' : 'pointer'
                }}
            >
                <span
                    style={{
                        paddingLeft: 10,
                        color: disabled ? '#919191' : '#414141',
                        fontSize: 14,
                        fontWeight: 500
                    }}
                >
                    {asDropdownTickBoxTextFormatter(values, localValues)}
                </span>
                <IconChevron style={{ width: 11, height: 22, paddingRight: 10 }}></IconChevron>
            </div>

            <div
                render={render}
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 29
                }}
            >
                {content()}
            </div>
        </div>
    );
};

AsDropdown.propTypes = {
    activeValues: PropTypes.array,
    disabled: PropTypes.bool,
    disabledValues: PropTypes.array,
    id: PropTypes.string,
    name: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    initialValue: PropTypes.any,
    inputStyle: PropTypes.object,
    labelStyle: PropTypes.object,
    onApply: PropTypes.func,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    onTick: PropTypes.func,
    optionStyle: PropTypes.object,
    placeholder: PropTypes.objectOf({
        id: PropTypes.any,
        name: PropTypes.any
    }),
    title: PropTypes.string,
    value: PropTypes.any,
    values: PropTypes.array,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default AsDropdown;
